import { makeStyles } from "@material-ui/core";

export default makeStyles((theme) => ({
  paper: {
    borderColor: theme.palette.separator.main,
    padding: theme.spacing(3, 0, 0, 3),
    marginBottom: theme.spacing(3),
    backgroundColor: theme.palette.otherElementsBackground.main,
    color: theme.palette.contrastText.main,
    "& svg": {
      fill: theme.palette.contrastIcon.main,
      "& path": {
        fill: theme.palette.contrastIcon.main,
      },
    },
  },
  content: {
    marginTop: theme.spacing(2),
  },
  settingsTitle: {
    color: theme.palette.contrastText.main,
  },
  title: {
    width: "240px",
    textTransform: "uppercase",
    color: "rgba(0, 0, 0, 0.6)",
    padding: `0 ${theme.spacing(2)} 0 12px`,
    verticalAlign: "top",
  },
  buttons: {
    verticalAlign: "top",
    paddingBottom: theme.spacing(1.5),
  },
  button: {
    padding: theme.spacing(1),
    color: theme.palette.contrastIcon.main,
  },
  logoFields: {
    verticalAlign: "bottom",
  },
  switchContainer: {
    marginLeft: theme.spacing(-1),
  },
  logoImage: {
    paddingBottom: theme.spacing(1),
  },
  uploadIcon: {
    fill: theme.palette.contrastIcon.main,
  },
}));
